export enum Retailer {
  AMAZON = "amazon",
  WALMART = "walmart",
  BESTBUY = "bestbuy",
  EBAY = "ebay",
  NEWEGG = "newegg",
}
